import { Component } from '@angular/core';

@Component({
  selector: 'rmt-center',
  templateUrl: 'rmt-center.html'
})
export class RmtCenterComponent {

  constructor() {    
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-center/rmt-center.ts